import type * as React from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast font-archivo group-[.toaster]:bg-white group-[.toaster]:text-[#09090B] group-[.toaster]:border group-[.toaster]:border-[#E5E7EB] group-[.toaster]:rounded-lg group-[.toaster]:shadow-[0px_4px_12px_0px_rgba(45,10,80,0.12)]',
          title: 'group-[.toast]:font-medium group-[.toast]:text-[#2D0A50]',
          description: 'group-[.toast]:text-[#6B7280]',
          actionButton: 'group-[.toast]:bg-[#2D0A50] group-[.toast]:text-white',
          cancelButton:
            'group-[.toast]:bg-[#F3F4F6] group-[.toast]:text-[#6B7280]',
          success: 'group-[.toast]:[&_[data-icon]]:text-[#00ccb0]',
          error: 'group-[.toast]:[&_[data-icon]]:text-[#EF3B4C]',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
